import type { StatusTone } from './statusColors';

/**
 * O TOM DO ATRASO (12/10/2026, bloco E da revisão aprovado pelo Heitor). Vencida é o estado que pede ação: âmbar até
 * 7 dias, vermelho depois. Vence hoje (0) ou a vencer não é atraso: sem tom.
 */
export const DIAS_DO_ATRASO_LEVE = 7;
export function tomDoAtraso(diasDeAtraso: number): Extract<StatusTone, 'warning' | 'danger'> | null {
  if (!(diasDeAtraso > 0)) return null;
  return diasDeAtraso <= DIAS_DO_ATRASO_LEVE ? 'warning' : 'danger';
}
